import { MenuActionItem } from '@creditornot/cb-menu';
import { LegacyPopover } from '@creditornot/cb-popover';
import styled from 'styled-components';

export const OptionPopover = styled(LegacyPopover).attrs({
  placement: 'bottom-start',
  showOnHover: false,
  showOnClick: false,
  renderArrow: false,
})``;

export const OptionPopoverContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 240px;
`;

export const Action = styled(MenuActionItem)`
  & + & {
    margin-block-start: 8px;
  }
`;
